import EditDriverView from "features/Fleet/FleetDriver/components/EditDriverView";
import useRouter from "hooks/useRouter";

EditFleetDriverScreen.propTypes = {};

function EditFleetDriverScreen(props) {
    // MARK: ---- PROPERTIES ----
    const router = useRouter();
    const driverId = router.query?.chargeDriverId;
    const agencyId = router.query?.agencyId;

    return (
        <div>
            <div className="my-4">
                <EditDriverView isAddCustomer={false} driverId={driverId} agencyId={agencyId} />
            </div>
        </div>
    );
}

export default EditFleetDriverScreen;
